import { render, staticRenderFns } from "./YKCRecentPages.vue?vue&type=template&id=29250eee&"
import script from "./YKCRecentPages.vue?vue&type=script&lang=js&"
export * from "./YKCRecentPages.vue?vue&type=script&lang=js&"
import style0 from "./YKCRecentPages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports